import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {ConfigService} from '@dcp/configurator';
import {LuigiContainer} from '@luigi-project/container';
import {LeadFormLuigiContext} from '@app/product/lead/lead.model';
import {CrmAccountTrackingService} from '@app/services/crm-account-tracking.service';
import {GoogleAutocompleteService} from '@app/services/google-autocomplete.service';

@Component({
  selector: 'dcp-private-offer-modal',
  standalone: true,
  templateUrl: './private-offer-modal.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PrivateOfferModalComponent implements OnInit {
  public container: WritableSignal<Partial<LuigiContainer>> = signal<Partial<LuigiContainer>>(undefined);
  public modalId: WritableSignal<string> = signal<string>('modal-private-offer-form');
  public url: WritableSignal<string> = signal<string>('');

  public context: LeadFormLuigiContext & { maps: any };

  private autocompleteService: GoogleAutocompleteService = inject(GoogleAutocompleteService);
  private configService: ConfigService = inject(ConfigService);
  private crmAccountTrackingService: CrmAccountTrackingService = inject(CrmAccountTrackingService);

  constructor() {
    this.url.set(this.configService.getString('webComponents.privateOfferFormModal'));
  }

  ngOnInit(): void {
    this.container.set(document.querySelector('#dcp-private-offer-form-modal'));

    this.crmAccountTrackingService.getAllParametersArray().forEach(param => {
      const paramValue = this.crmAccountTrackingService.getDataFromSessionStorage(param);

      this.context = {...this.context, sessionStorageUserDataExist: !!paramValue, [param]: paramValue}
    })

    this.container().addEventListener('initialized', () => {
      this.autocompleteService.isLoaded().then(() => {
        this.context = {...this.context, maps: window.google.maps}
        this.modalId.set(this.context.modalId || this.modalId())
      })
    })
  }
}
